export enum PresenceRejet {
    Inconnue = 0,
    Absence = 1,
    Amont = 2,
    Aval = 3,
    EntreDeuxRejets = 4,
    PrelevementSurRejet = 5
}
